import { TextField, Button } from "@mui/material";
import React from "react";

import { server } from "../../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useSelectAccess } from "../../../store/stateFunctions";

const initialValues = {
  fullname: "",
  email: "",
  feedback: "",
};
const IndustryFeedback = ({ role }) => {
  const user = useSelectAccess("Industry User");

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      fullname: Yup.string()
        .min(2, "Enter a Full Name")
        .required("Please Enter a Full Name"), // Should be min(1) or min(2) or any other number
      email: Yup.string()
        .min(2, "Enter Email Id")
        .required("Please Enter Your Email Id"),
      feedback: Yup.string()
        .min(2, "Select Date")
        .required("Please Enter Your Feedback"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post("/feedback/addfeedback", values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Feedback Sent successfully");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  return (
    <>
      <section className="">
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-8">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className=" ">
                    <div className="card-body p-4 text-black">
                      <form onSubmit={handleSubmit}>
                        <h5
                          className="fw-normal mb-3 pb-3"
                          style={{ letterSpacing: 1 }}
                        >
                          Share Feedback
                        </h5>
                        <div className="form-outline mb-2">
                          <TextField
                            name="fullname"
                            margin="dense"
                            type="text"
                            placeholder="Fullname"
                            variant="outlined"
                            label="Fullname"
                            value={values.fullname}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.fullname ? (
                            <p className="text-danger">{errors.fullname}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="email"
                            margin="dense"
                            type="email"
                            placeholder="Email Id"
                            variant="outlined"
                            label="Email Id"
                            value={values.email}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.email ? (
                            <p className="text-danger">{errors.email}</p>
                          ) : null}
                        </div>

                        <div className="form-outline mb-2">
                          <TextField
                            name="feedback"
                            margin="dense"
                            type="text"
                            placeholder="Feedback"
                            variant="outlined"
                            label="Feedback"
                            value={values.feedback}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.feedback ? (
                            <p className="text-danger">{errors.feedback}</p>
                          ) : null}
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="banner text-white rounded-5 p-2 border-0 w-50"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryFeedback;
